import { render } from "./custodianModel.vue?vue&type=template&id=35fdb57a"
import script from "./custodianModel.vue?vue&type=script&lang=js"
export * from "./custodianModel.vue?vue&type=script&lang=js"

import "./custodianModel.vue?vue&type=style&index=0&id=35fdb57a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__